import request from '@/utils/request'

// 获取指定年份的日历数据（公众假期）
export function getCalendarByYear () {
  return request({
    url: '/api/calendar',
    method: 'GET'
  })
}
